import { stringify } from 'qs';
import { query } from 'src/utils/request';

// 医疗收入明细列表
export const getMedicalIncomeList = data => {
  return query('/zlb/budget/ep/medical/income/page', {
    method: 'POST',
    data,
  });
};

// 病案数据列表
export const getMedicalRecordList = data => {
  return query('/zlb/budget/ep/medical/record/page', {
    method: 'POST',
    data,
  });
};

// 补录病案信息
export const addMedicalRecord = data => {
  return query('/zlb/budget/ep/medical/record/add', {
    method: 'POST',
    data,
  });
};

// 更新补录病案信息
export const updateMedicalRecord = data => {
  return query('/zlb/budget/ep/medical/record/update', {
    method: 'POST',
    data,
  });
};

// 删除病案信息
export const deleteMedicalRecord = data => {
  return query(`/zlb/budget/ep/medical/record/delete/${data.uk}`, {
    method: 'POST',
  });
};

// 查询his系统单位
export const getMedicalDeptList = params => {
  return query('/zlb/budget/ep/medical/basic-data/dept', {
    params,
  });
};
